import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles((theme) => ({
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  table: {
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '600px',
      overflowX: 'auto'
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#666687',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '11px',
      backgroundColor: '#EEF7FF'
    },
    '& .MuiTableBody-root': {
      paddingLeft: '20px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      color: '#777',
      padding: '6px 4px'
    },
    '& .MuiSvgIcon-root': {
      fill: '#4B6FC2',
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px',
      margin: '0',
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    },
    '& .indicator': {
      borderRadius: '10px',
      fontWeight: '500',
      fontSize: '12px',
      lineHeight: '15px',
      padding: '5px 10px',
      textTransform: 'capitalize',
      background: '#E1E1E1',
      color: '#000'
    },
  },
  patientActivityTableImage: {
    filter: 'drop-shadow(0px 1px 4px rgba(33, 33, 52, 0.1))',
    borderRadius: '4px',
    maxHeight: '60px',
    width: '100%',
    minWidth: '60px',
    objectFit: 'contain',
    padding: '5px'
  },
  paginationContainer: {
    background: '#EEF7FF',
    color: '#666687',

    '& .MuiSelect-icon': {
      color: '#666687'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#666687',
      opacity: '0.44'
    }
  },
  modalTitle: {
    fontWeight: 700,
    fontSize: '16px',
    textTransform: 'uppercase',
    letterSpacing: '0.15px',
    color: '#4B6FC2',
    marginBottom: '25px'
  },
  customized_editor: {
    '& .jodit-react-container, &.jodit-container:not(.jodit_inline)': {
      borderRadius: '4px'
    },
    '& .jodit-container:not(.jodit_inline)': {
      border: '1px solid rgba(0, 0, 0, 0.23)'
    }
  },
  inactiveItem: {
    backgroundColor: theme.palette.grey[200],
  },
  badge: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    padding: '0 4px',
    borderRadius: '4px',
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}));
